/* eslint-disable no-param-reassign */
import { Swiper, Navigation, Pagination } from 'swiper';
import { Fancybox } from '@fancyapps/ui';

function updateNavigationVisibility(swiper, prevBtn, nextBtn) {
  prevBtn.classList.toggle('btn-hide', swiper?.isBeginning);
  nextBtn.classList.toggle('btn-hide', swiper?.isEnd);
}

function updateCaptionLocation() {
  setTimeout(() => {
    document.querySelectorAll('.fancybox__slide').forEach((slide) => {
      const caption = slide.querySelector('.fancybox__caption');
      const wrapper = slide.querySelector('.fancybox__content');

      if (caption && wrapper && !wrapper.contains(caption)) {
        wrapper.appendChild(caption);
      }
    });
  }, 50);
}

document.querySelectorAll('.gallery-lightbox').forEach((gallery) => {
  const nextBtn = gallery.querySelector('.swiper-button-next');
  const prevBtn = gallery.querySelector('.swiper-button-prev');
  const swiperContainer = gallery.querySelector('.swiper-container');
  let swiper;

  const initSwiper = () => {
    if (swiper && typeof swiper.destroy === 'function') {
      swiper.destroy(true, true);
    }

    /* eslint-disable */
    swiper = new Swiper(swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        576: {
          spaceBetween: 24,
        },
      },
      pagination: {
        el: gallery.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: (index, className) => `<button type="button" class="${className}" aria-label="Slide ${index + 1}"></button>`,
      },
      watchSlidesProgress: true,
      watchOverflow: true,
      loop: false,
      on: {
        init(swiper) {
          updateNavigationVisibility(swiper, prevBtn, nextBtn);
        },
        slideChange(swiper) {
          updateNavigationVisibility(swiper, prevBtn, nextBtn);
        },
      },
    });
    /* eslint-enable */

    swiper.slides.forEach((slide, index) => {
      slide?.querySelector('a')?.addEventListener('focus', () => {
        swiper.slideTo(index);
      });
    });
  };

  if (gallery.getAttribute('data-lightbox')) {
    Fancybox.bind('[data-fancybox]', {
      on: {
        reveal: updateCaptionLocation,
        done: updateCaptionLocation,
        resize: updateCaptionLocation,
      },
    });
  }

  initSwiper();
});
